var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1705 23.3533L15.4153 23.1512C16.1186 23.038 16.7734 22.7066 17.2746 22.1974L18.4305 21.0414C18.9559 20.516 18.9559 19.6672 18.4305 19.1418L15.771 16.4823C15.2456 15.9569 14.3968 15.9569 13.8714 16.4823L11.9394 18.4143L5.56961 12.0444L7.50157 10.1125C8.027 9.58706 8.027 8.73828 7.50157 8.21286L4.84209 5.55337C4.31666 5.02794 3.46789 5.02794 2.94246 5.55337L1.78651 6.70932C1.27725 7.21858 0.945827 7.86526 0.832657 8.56853L0.630569 9.81339C0.452731 10.8885 0.808407 11.9879 1.58443 12.7558L11.2119 22.3833C11.9798 23.1512 13.0792 23.5069 14.1543 23.3371L14.1705 23.3533Z",
    fill: "#474C55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1068 3.83966C13.3621 4.04983 15.5528 5.01177 17.2745 6.73356C18.9963 8.45536 19.9583 10.646 20.1684 12.9013",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1068 3.83966C13.3621 4.04983 15.5528 5.01177 17.2745 6.73356C18.9963 8.45536 19.9583 10.646 20.1684 12.9013",
    stroke: "#474C55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9108 12.8932C16.7168 11.4705 16.0782 10.1044 14.9869 9.01311C13.8956 7.92184 12.5295 7.28324 11.1068 7.08923",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9108 12.8932C16.7168 11.4705 16.0782 10.1044 14.9869 9.01311C13.8956 7.92184 12.5295 7.28324 11.1068 7.08923",
    stroke: "#474C55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTel);
export default __webpack_public_path__ + "static/media/icon_tel.905871f44a2475c894ec00afd2cf38d5.svg";
export { ForwardRef as ReactComponent };